import { useCount } from "@/utils/count";

const load = async () => {
    await useCount().countMyFeedback();
};
export default [
    {
        path: "/common",
        name: "common__root__",
        redirect: {
            name: "common-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "common",
            title: "",
        },
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        children: [
            {
                path: "index",
                name: "common-index",
                component: () => import("@/views/common/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/common/account",
        name: "common_account",
        meta: {
            title: "个人中心",
            icon: "user",
            parent: "common",
        },
        // hidden: true,
        component: () => import("@/layouts/default.vue"),
        redirect: "/common/account/message",
        children: [
            {
                path: "setting",
                name: "common-account-setting",
                component: () => import("@/views/common/account/setting.vue"),
                meta: {
                    title: "资料设置",
                    icon: "setting",
                    affix: false,
                },
            },
            {
                path: "message",
                name: "common-account-message",
                component: () => import("@/views/common/account/message.vue"),
                meta: {
                    title: "通知消息",
                    icon: "message",
                    affix: false,
                },
            },
            {
                path: "feedback",
                name: "common-account-feedback",
                component: () => import("@/views/common/account/my-feedback.vue"),
                meta: {
                    title: "反馈工单",
                    icon: "feedback",
                    affix: false,
                },
            },
            {
                path: "feedback-detail/:id(\\d+)",
                name: "common-account-feedback-detail",
                hidden: true,
                component: () => import("@/views/common/account/feedback-detail.vue"),
                meta: {
                    title: "反馈工单",
                    icon: "feedback",
                    affix: false,
                    activeMenu: "/common/account/feedback",
                },
            },
        ],
    },
];
